import config from '@/config/index'
const BASE_URL = config.uploadUrl
export default {
  fileUpload: BASE_URL + '/File/upLoad', //文件上传
}
